'use client'

import { Button } from '@/components/ui/common/Button'
import { useMemo } from 'react'

interface Symbol {
  id: string
  value: string
  isTarget: boolean
  isSelected: boolean
}

interface TaskCardProps {
  currentRowIndex: number
  rowCount: number
  rows: Symbol[][]
  disabled: boolean
  onToggleSymbol: (rowIndex: number, symbolIndex: number) => void
  onNextRow: () => void
  className?: string
}

export default function TaskCard({
  currentRowIndex,
  rowCount,
  rows,
  disabled,
  onToggleSymbol,
  onNextRow
}: TaskCardProps) {
  if (!rows.length || !rows[currentRowIndex]) return null

  const generateKey = useMemo(() => {
    return Math.random().toString(36).substring(2, 15)
  }, [])

  return (
    <div className="flex flex-col items-center gap-8 py-8">
      <div className="sr-only">
        <p>Znajdź wszystkie symbole</p>
      </div>

      <div className="w-full">
        <div className="flex flex-wrap justify-center gap-2 rounded-lg border bg-gray-50 p-4">
          {rows[currentRowIndex].map((symbol, symbolIndex) => (
            <button
              aria-label={`Symbol ${symbolIndex + 1}: ${symbol.value}`}
              className={`flex h-10 w-10 items-center justify-center rounded-md border font-mono text-lg transition-colors ${
                symbol.isSelected
                  ? 'border-indigo-400 bg-indigo-100'
                  : 'border-gray-200 bg-white hover:border-indigo-300'
              }`}
              key={`${generateKey}-${symbolIndex}`}
              onClick={() => onToggleSymbol(currentRowIndex, symbolIndex)}
            >
              {symbol.value}
            </button>
          ))}
        </div>
      </div>

      <Button
        className="mt-4 bg-[#2bcaca] hover:bg-[#2b9999]"
        disabled={disabled}
        onClick={onNextRow}
      >
        {currentRowIndex === rowCount - 1 ? 'Zakończ' : 'Następny wiersz'}
      </Button>
    </div>
  )
}
